// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnreadMessages_root__lHrOm {
  padding: 16px 0;
}

.UnreadMessages_content__jIKIh {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  background: #F7F7F7;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #8E8E93;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/UnreadMessagesAlert/UnreadMessages.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,yBAAA;UAAA,iBAAA;AAFF","sourcesContent":[".root {\n  padding: 16px 0;\n\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 10px;\n  background: #F7F7F7;\n\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #8E8E93;\n\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UnreadMessages_root__lHrOm`,
	"content": `UnreadMessages_content__jIKIh`
};
export default ___CSS_LOADER_EXPORT___;
